import PartnersList from './partners-list';

export default PartnersList;